<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户名称" :value="4"></el-option>
                            <el-option label="演出ID" :value="2"></el-option>
                            <el-option label="周边ID" :value="5"></el-option>
                            <el-option label="订单编号" :value="3"></el-option>
							<el-option label="领券手机号" :value="6"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.dateType" slot="prepend" placeholder="请选择">
                                <el-option label="领取时间" :value="1"></el-option>
                                <el-option label="使用时间" :value="2"></el-option>
                                <el-option label="过期时间" :value="3"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="params.time"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制状态" :value="-1"></el-option>
                        <el-option label="仅看已使用的" :value="1"></el-option>
                        <el-option label="仅看未使用的" :value="2"></el-option>
                        <!-- <el-option label="仅看已锁定的" :value="3"></el-option> -->
                        <el-option label="仅看已过期的" :value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">					
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
		<div class="page-btns-box">
		    <el-button  type="primary"  size="small" @click="uploadList()">导出明细</el-button>
		</div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="reciveTime" label="领取时间" :min-width="150"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 1">已使用</span>
                        <span v-else-if="scope.row.status === 2">未使用</span>
                        <span v-else-if="scope.row.status === 3">已锁定</span>
                        <span v-else-if="scope.row.status === 4">已过期</span>
                    </template>
                </el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="telephone" label="用户手机号" min-width="100"></el-table-column>
                <el-table-column prop="userName" label="用户名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="useBusiness" label="使用业务"></el-table-column>
                <el-table-column prop="businessId" label="业务ID"></el-table-column>
				<el-table-column prop="goodsName" label="业务名称" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="orderSn" label="订单编号" min-width="120"></el-table-column>
                <el-table-column prop="useTime" label="使用时间" min-width="150"></el-table-column>
				<el-table-column prop="subsidyStr" label="承担方" min-width="150"></el-table-column>
                <!-- <el-table-column prop="couponName" label="优惠券名称" :min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="couponPrice" label="金额"></el-table-column>
                <el-table-column prop="couponSubtractPrice" label="满减"></el-table-column>
                <el-table-column prop="limitIds" label="演出限制" :min-width="110" show-overflow-tooltip></el-table-column>
                <el-table-column label="有效期" :min-width="300">
                    <template slot-scope="scope">
                        {{`${scope.row.beginTime} 至 ${scope.row.endTime}`}}
                    </template>
                </el-table-column>
                <el-table-column label="使用范围">
                    <template slot-scope="scope">
                        <span v-if="scope.row.useTerminal === 0">所有平台</span>
                        <span v-else-if="scope.row.useTerminal === 1">APP</span>
                    </template>
                </el-table-column> -->
                <el-table-column fixed="right" label="操作" :width="100">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="snapshotHandler(scope.row.id)">优惠券快照</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <CouponSnapshot ref="couponSnapshot"></CouponSnapshot>
    </div>
</template>

<script>
import CouponSnapshot from './components/CouponSnapshot';
import {downloadFileTmp} from '@/assets/js/commonApi.js';
export default {
    components:{CouponSnapshot},
    data(){
        this.defaultParams = {
            couponRuleId: this.$route.params.id,
            type: 1,
            value: null,
            dateType: 1,
            time: null,
            status: -1,
            pageNo: 1,
            pageSize: this.$pageSizes[0]
        };

        return {
            data: [],
            dataList: [],
            params:{
                ...this.defaultParams,
                type: parseInt(this.$route.query.type || 1),
                value: this.$route.query.value || null,
                dateType: parseInt(this.$route.query.dateType || 1),
                date: this.$route.query.startDate && this.$route.query.endDate ? [this.$route.query.startDate, this.$route.query.endDate] : null,
                status: parseInt(this.$route.query.dateType || -1),
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])
            },
            listLoading: true,
			uploadLoading:false
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        async getDataList() {
            const {time, ...filterData} = this.params;
            const [startDate, endDate] = time || [];

            this.listLoading = true;

            const res = await this.$request({
                url: '/coupon/use/list',
                method: 'post',
                data: {...filterData, startDate, endDate}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...this.defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //优惠券快照
        snapshotHandler(id){
            this.$refs.couponSnapshot.show(id)
        },
		uploadList(){
			const {time, ...filterData} = this.params;
			const [startDate, endDate] = time || [];
			
		   var now = this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd HH:mm:ss' );			
		   let filePath;
		   this.uploadLoading = true;
			this.$request({
				url: '/coupon/export/use/list',
				method: 'POST',
				data: {...filterData, startDate, endDate} ,
			}).then(res => {
				const { state, msg, result } = res.data;
				if( state == 1 && result ){
					filePath = result.url;					
					downloadFileTmp(filePath, '优惠券'+this.defaultParams.couponRuleId+'使用明细.'+this.$utils.getFileType(filePath));
					this.uploadLoading = false;
				}else{
					this.uploadLoading = false;
					return this.$message.error(msg || '下载失败');
				}
			}).catch(() => {
				this.$message.error('请求错误');
			}).finally(() => {
				this.uploadLoading = false;
			});
					
		},
		
    }
}
</script>